// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"282":"8f52dff0","514":"28c2f671","938":"95ff3cd9"}[chunkId] + ".chunk.js";
};